import { useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import styles from './BookingSuccess.module.css';

export default function BookingSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  return (
    <div className={styles.page}>
      <div className={styles.stateCard}>
        <div className={`${styles.stateIcon} ${styles.stateIconSuccess}`}>
          <CheckCircle size={32} aria-hidden="true" />
        </div>
        <h1 className={styles.stateTitle}>Payment Confirmed!</h1>
        <p className={styles.stateBody}>
          Your booking is confirmed and a confirmation email is on its way.
        </p>
      </div>
      <div className={styles.footer}>
        <p>Powered by <span className={styles.footerBrand}>Vennio</span></p>
      </div>
    </div>
  );
}
